"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var es6_promise_1 = __importDefault(require("es6-promise"));
es6_promise_1.default.polyfill();
require("../loader.scss");
require("./custom-main.scss");
var lodash_1 = require("lodash");
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var Component_1 = require("../lib/Component");
var NsrAddonApi_1 = require("../lib/NsrAddonApi");
var util_1 = require("../lib/util");
var contants_1 = require("../lib/contants");
var CustomMain = /** @class */ (function (_super) {
    __extends(CustomMain, _super);
    function CustomMain(element) {
        var _this = _super.call(this, element) || this;
        _this.listReq$ = new rxjs_1.Subject();
        _this.listReq$
            .pipe(operators_1.takeUntil(_this.destroy$), operators_1.switchMap(function (params) {
            _this.portfolios = 'loading';
            return NsrAddonApi_1.NsrAddonApi.listCustomPortfolios(params).pipe(operators_1.catchError(function () { return rxjs_1.EMPTY; }));
        }))
            .subscribe(function (res) {
            _this.portfolios = res.data;
        });
        return _this;
    }
    Object.defineProperty(CustomMain.prototype, "portfolios", {
        set: function (pfList) {
            this._portfolios = pfList;
            this.renderPortfolios(pfList);
        },
        enumerable: false,
        configurable: true
    });
    CustomMain.prototype.onInit = function () {
        console.log('CustomMain.onInit()');
        this.$element.empty().addClass('tabContentWrap').append(this.renderDesignFilter(), util_1.$div('dep1_wrap'));
        this.onSearch({ design: '전체' });
    };
    CustomMain.prototype.renderDesignFilter = function () {
        var _this = this;
        var tab = util_1.$div('tab_dep1');
        tab.append(util_1.$div('btn', { 'data-design': '전체' }).append(util_1.$element('p').setText('전체')).on('click', function () { return _this.onClickDesignOption({ design: '전체', name: '전체' }); }));
        var _loop_1 = function (d) {
            tab.append(util_1.$div('btn', { 'data-design': d.design }).append(util_1.$element('p').setText(d.name)).on('click', function () { return _this.onClickDesignOption(d); }));
        };
        for (var _i = 0, DESIGN_LINES_1 = contants_1.DESIGN_LINES; _i < DESIGN_LINES_1.length; _i++) {
            var d = DESIGN_LINES_1[_i];
            _loop_1(d);
        }
        return tab;
    };
    CustomMain.prototype.renderPortfolios = function (pfList) {
        var _this = this;
        var wrap = this.$element.findFirst('.tabContentWrap .dep1_wrap');
        if (!wrap)
            return;
        var $portfolio_list = util_1.$div('portfolio_list');
        var $content = util_1.$div('dep1_content').append(util_1.$div('portfolioWrap portfolio_layout').append($portfolio_list));
        if (lodash_1.isArray(pfList)) {
            $content.addClass('fade-out');
            if (pfList.length) {
                var $ul = util_1.$element('ul');
                var maxLength = Math.min(pfList.length, 12);
                var _loop_2 = function (i) {
                    var pf = pfList[i];
                    var $li = util_1.$element('li').append(util_1.$div('img').append(util_1.$element('img', { src: pf.thumb })), util_1.$div('text_cont').append(util_1.$element('p', 'title').setText(pf.pfname), util_1.$element('p', 'text').setText(pf.brief), util_1.$element('p', 'level').setText(pf.design))).on('click', function () { return _this.onOpenPortfolio(pf); });
                    $ul.append($li);
                };
                for (var i = 0; i < maxLength; i++) {
                    _loop_2(i);
                }
                $portfolio_list.append($ul);
            }
            else {
                $portfolio_list.append(util_1.$div('message').setText('해당하는 포트폴리오가 없습니다'));
            }
        }
        else if (lodash_1.isString(pfList)) {
            $portfolio_list.append(util_1.$div('loader loader-md'));
        }
        util_1.$helper(wrap).empty().append($content);
        setTimeout(function () { return $content.removeClass('fade-out'); }, 100);
    };
    CustomMain.prototype.onClickDesignOption = function (d) {
        this.onSearch({ design: d.design });
    };
    CustomMain.prototype.onSearch = function (params) {
        var design = params ? params.design : '전체';
        this.highlightDesign(design);
        this.listReq$.next({ design: design === '전체' ? undefined : design });
    };
    CustomMain.prototype.onOpenPortfolio = function (pf) {
        location.href = '/shopinfo/portfolio_detail.html?pfno=' + pf.pfno;
    };
    CustomMain.prototype.highlightDesign = function (design) {
        this.$element.findAll('.tabContentWrap .tab_dep1 > .btn').forEach(function (item) {
            var $item = util_1.$helper(item);
            var attrDesign = $item.getAttr('data-design');
            $item.toggleClass('select', design === attrDesign);
        });
    };
    return CustomMain;
}(Component_1.Component));
window.addEventListener('DOMContentLoaded', function () {
    console.log('Initializing nsr-addon.custom-main');
    var container = document.querySelector('.nsr-addon-container');
    if (container) {
        new CustomMain(container).init();
    }
});
